import { setIDFACollectionEnabled } from 'app/lib/analytics';
import { recordError } from 'app/lib/monitoring';
import { isMobileNative } from 'app/utils/web-helpers';
import doublet from 'doublet';
import { requestTrackingPermissionsAsync } from 'expo-tracking-transparency';
import { useEffect } from 'react';

export function useFacebookSDK() {
  useEffect(() => {
    const promptATT = async () => {
      if (!isMobileNative) return;

      const [error, result] = await doublet(() => requestTrackingPermissionsAsync());
      const granted = result?.granted ?? false;

      if (error) {
        console.error('Failed to requestTrackingPermissionsAsync() in useFacebookSDK()');
        recordError(error);
      }

      await setIDFACollectionEnabled(granted);
    };

    void promptATT();
  }, []);
}
